// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import { actions } from './'
import Regulation from './Regulation'

const mapStateToProps = (
  {
    regulations,
    oidc: {
      user: { profile }
    }
  },
  ownProps
) => {
  let catalogId = profile && profile['custom:catalog_id']
  let campaignId = profile && profile['custom:campaign_id']
  let index = `${campaignId || '-'}${catalogId || '-'}${
    ownProps.vendorId ? ownProps.vendorId : '-'
  }${ownProps.regulationType ? ownProps.regulationType : '-'}`
  let regulationItem = regulations && regulations[index]
  return {
    regulations:
      regulationItem && regulationItem.result
        ? regulationItem.result.map(regulation => regulation.html)
        : [],
    // loaded: regulationItem.loaded,
    catalogId: catalogId,
    campaignId: campaignId
  }
}

const mapDispatchToProps = dispatch => {
  return ({
    listRegulationsVendor: (campaignId, catalogId, vendorId) =>
      vendorId && catalogId && campaignId && dispatch(actions.listRegulationsVendor(campaignId, catalogId, vendorId)),
    listRegulationsVendorAndRegulationType: (
      campaignId,
      catalogId,
      vendorId,
      regulationType
    ) =>
      vendorId && catalogId && campaignId && regulationType &&
      dispatch(
        actions.listRegulationsVendorAndRegulationType(
          campaignId,
          catalogId,
          vendorId,
          regulationType
        )
      )
  })
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Regulation)



// WEBPACK FOOTER //
// ./src/features/Regulation/RegulationContainer.js